import React, { useState } from "react";
import { requestArchiveCode, verifyArchiveCode } from "services/storageService/storageService";
import { ActionButton, CodeInput, ErrorText, Modal, ModalActions, ModalBackdrop, ModalTitle, Subtitle } from "pages/StoragePage/StoragePage.styles";

export default function ArchiveConfirmation({ onConfirm, onCancel }: { onConfirm: () => Promise<void>; onCancel: () => void }) {
  const [code, setCode] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const send = async () => {
    setBusy(true); setError("");
    try { await requestArchiveCode(); setSent(true); setCode(""); }
    catch (e: any) { setError(e?.response?.data?.detail || "Не удалось отправить код."); }
    finally { setBusy(false); }
  };
  const confirm = async () => {
    setBusy(true); setError("");
    try { await verifyArchiveCode(code); await onConfirm(); }
    catch (e: any) { setError(e?.response?.data?.detail || "Не удалось подтвердить действие."); }
    finally { setBusy(false); }
  };
  return <ModalBackdrop><Modal role="dialog" aria-modal="true" aria-labelledby="archive-confirm-title">
    <ModalTitle id="archive-confirm-title">Отправить курс в архив?</ModalTitle>
    <Subtitle>Это не удаляет курс и не закрывает доступ ученикам. Вернуть курс можно через «Хранилище». Для подтверждения получите код на почту школы.</Subtitle>
    {sent ? <><Subtitle>Код действует 5 минут. При необходимости новый код можно запросить сразу.</Subtitle><CodeInput aria-label="Код архивации" inputMode="numeric" autoComplete="one-time-code" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))} /></> : null}
    {error ? <ErrorText role="alert">{error}</ErrorText> : null}
    <ModalActions>
      <ActionButton disabled={busy} onClick={onCancel}>Отмена</ActionButton>
      <ActionButton disabled={busy} onClick={() => void send()}>{sent ? "Получить новый код" : "Получить код"}</ActionButton>
      {sent ? <ActionButton $primary disabled={busy || code.length !== 6} onClick={() => void confirm()}>Подтвердить архивацию</ActionButton> : null}
    </ModalActions>
  </Modal></ModalBackdrop>;
}
